import { render, staticRenderFns } from "./QuantityFixed.vue?vue&type=template&id=36d8858c&scoped=true&lang=pug"
import script from "./QuantityFixed.vue?vue&type=script&lang=js"
export * from "./QuantityFixed.vue?vue&type=script&lang=js"
import style0 from "./QuantityFixed.vue?vue&type=style&index=0&id=36d8858c&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d8858c",
  null
  
)

export default component.exports